import { configureStore } from "@reduxjs/toolkit";
import lotteryReducer from "./features/lotteryReducer";
import resultlotteryReducer from "./features/resultlotteryReducer";
import authenticationReducer from "./features/loginAuthenReducer";
import lotteryInvoice from "./features/lotteryInvoice";
import creditReducer from "./features/creditReducer";
const store = configureStore({
  reducer: {
    lottery: lotteryReducer,
    result: resultlotteryReducer,
    login: authenticationReducer,
    invoice: lotteryInvoice,
    credit: creditReducer,
  },
});

export default store;
